import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'

export function WavePlansBackLink() {
  return (
    <Link
      to="/wave-planning"
      className="mb-2 inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-primary"
    >
      <ArrowLeft size={13} /> Back to plans
    </Link>
  )
}
